export default {"src":"https://prisma-hub-prisma.vercel.app/_next/static/media/icon-prisma-guides.4df6dea7.svg","height":49,"width":49};